import { select as D3select } from 'd3';
import { EltPlacement, AddValueLine } from './utils';

const D3Tooltips = function () {
    // default settings can be overridden
    let color = 'black';
    let bounds = { width: 100, height: 100 };
    let position = 'top';
    let arrow = true;
    let offset = 0.25;
    let theme;

    let self;
    let path = 'M -5 8 l 5 5 5 -5 z';
    const opacity = '1';

    function my (selection) {
        if (!selection) return;
        selection.each(function (data, i) {
            // container for stuff that's only added once, e.g., titles and tooltips
            self = this;
            const g = D3select(self).selectAll('g.tooltips').data(['tooltips']);

            // fancy tooltips
            const container = g.enter().append('g')
                .attr('class', 'tip tooltips')
                .style('pointer-events', 'none');

            container.append('rect')
                .attr('class', 'tip-rect')
                .attr('x', 0)
                .attr('y', 0)
                .attr('rx', 2)
                .attr('ry', 2)
                .style('pointer-events', 'none')
                .style('fill', theme.palette.background.paper)
                .style('stroke', theme.palette.info.dark);

            container.append('text')
                .attr('class', 'tip-text')
                .attr('text-anchor', 'start')
                .attr('x', 5)
                .attr('y', 15)
                .attr('dy', 0)
                .attr('dx', 0)
                .style('pointer-events', 'none')
                .style('white-space', 'nowrap')
                .style('font', theme.typography.tooltips.font)
                .style('fill', theme.palette.text.primary)
                .style('color', theme.palette.common.white)
                .style('font-weight', 'bold');

            g.enter().append('g')
                .attr('class', 'tip-pointer')
                .append('path')
                .style('pointer-events', 'none')
                .style('fill-opacity', '0')
                .attr('d', path);
        });
    }

    // getters/setters
    my.color = function (v) {
        if (!arguments.length) return color;
        color = v;
        return my;
    };

    my.bounds = function (v) {
        if (!arguments.length) return bounds;
        bounds = v;
        return my;
    };

    my.position = function (v) {
        if (!arguments.length) return position;
        position = v;
        path = position === 'top' ? 'M -5 8 l 5 5 5 -5 z' : 'M -5 8 l 5 -5 5 5 z';
        return my;
    };

    my.arrow = function (v) {
        if (!arguments.length) return arrow;
        arrow = v;
        return my;
    };

    my.offset = function (v) {
        if (!arguments.length) return offset;
        offset = v;
        return my;
    };

    my.theme = function (v) {
        if (!arguments.length) return theme;
        theme = v || theme;
        return my;
    };

    // behavior
    my.show = function () {
        D3select(self).selectAll('.tooltips .tip-text')
            .transition().duration(theme.transitions.duration.complex)
            .style('opacity', '1')
            .style('fill-opacity', '1');
        D3select(self).selectAll('.tooltips rect')
            .transition().duration(theme.transitions.duration.complex)
            .style('fill-opacity', opacity)
            .style('stroke-opacity', 1);
        D3select(self).selectAll('.tip-pointer path')
            .transition().duration(theme.transitions.duration.complex)
            .style('fill-opacity', arrow ? opacity : '0');
        return my;
    };

    my.hide = function () {
        D3select(self).selectAll('.tooltips .tip-text')
            .transition().duration(theme.transitions.duration.complex)
            .style('opacity', '0')
            .style('fill-opacity', '0');
        D3select(self).selectAll('.tooltips rect')
            .transition().duration(theme.transitions.duration.complex)
            .style('fill-opacity', '0')
            .style('stroke-opacity', '0');
        D3select(self).selectAll('.tip-pointer path')
            .transition().duration(theme.transitions.duration.complex)
            .style('fill-opacity', '0');
        return my;
    };

    // vals in rows of up to 3 strings each. a new tooltip line is created per row.
    // e.g.
    // [[key, value], [key, value, value]]
    // [[info]]
    my.move = function (x, y, vals) {
        my.show();
        D3select(self).selectAll('.tooltips')
            .attr('transform', function (graph, i) {
                const rect = D3select(self).select('.tip-rect');
                const text = D3select(self).select('.tip-text').text(null);
                const arrw = D3select(self).select('.tip-pointer');

                if (!text.node()) {
                    my.hide();
                    return 'translate(0,0)';
                }
                vals.forEach((v, i) => AddValueLine(text, v, i, theme));

                const h = text.node().getBBox().height + 10;
                const w = text.node().getBBox().width + 10;

                rect.attr('width', w)
                    .attr('height', h);
                // get tooltip scooted location
                // we use eltPlacement for x-axis scooting.
                const cx = x - (offset * w);
                const cy = position === 'top' ? y : y + h + 47;
                const place = EltPlacement(
                    { left: cx, bottom: y - 10, right: cx + offset, top: y - 10 - h },
                    rect.node().getBBox(),
                    { w: bounds.width, h: bounds.height },
                    offset * w, // in case we need to reposition to left edge
                );
                arrw.attr('transform',
                    'translate(' + x + ',' + (position === 'top' ? cy + 5 : y + 42) + ')')
                    .select('path')
                    .attr('d', path);
                return 'translate(' + place.l + ', ' + place.t + ')';
            });
        return my;
    };

    return my;
};

export default D3Tooltips;
